export enum StageInfluenceGroupingType {
    CampaignTypes = 'campaign_types',
    Campaigns = 'campaigns',
}
